// Import Bootstrap's JavaScript
import 'bootstrap';

// Import your main SCSS file
import './style.scss';